import classNames from 'classnames/bind';
import styles from './Invite.module.scss';

const cx = classNames.bind(styles);
function Invite() {
    return <div className={cx('wrapper')}>Invite a Friend</div>;
}

export default Invite;
